import { Collection } from '@msw/data'
import { persist } from '@msw/data/extensions/persist'
import { familyMembersSchema } from 'app/src/msw/membership/schemas/familyMembers'
import type { UserFamilyMember } from 'app/src/services/welfareportal'

// FAMILY MEMBERS COLLECTION
const familyMembersCollection = new Collection({
  schema: familyMembersSchema,
  extensions: [persist()],
})

export { familyMembersCollection }

export const createFamilyMembersSeed = async () => {
  const existingData = await familyMembersCollection.findMany()

  console.log('MSW: Checking existing Family Members data, found', existingData.length)

  if (existingData.length > 0) {
    return
  }

  const jsonData = await (await fetch('./data/membership/familyMembers.json')).json()
  jsonData.items.forEach(async (item: UserFamilyMember) => {
    const createdFamilyMember = await familyMembersCollection.create(item)
    console.log('createFamilyMembersSeed', createdFamilyMember)
  })
  console.log('MSW: Seeding Family Members data')
}

export const clearFamilyMembersSeed = async () => {
  const existingData = await familyMembersCollection.findMany()
  existingData.forEach(async (item) => {
    await familyMembersCollection.delete(item)
  })
  console.log('MSW: Cleared Family Members data')
}
